export const getHomeRedirectURL = windowLocation => {
  const parseHashOutOfQuery = hash => {
    const [path, query] = hash.split("?");
    return { path, query };
  };

  const { path, query: hashQuery } = parseHashOutOfQuery(windowLocation.hash);
  const searchParams = new URLSearchParams(windowLocation.search);
  const queryString = hashQuery || searchParams.toString();
  const queryParams = queryString ? `?${queryString}` : "";

  return `/home${path.replace("#", "")}${queryParams}`;
};

export const homeRedirect = () => {
  fetch("/beta-home-dewey")
    .then(response => {
      if (!response.ok) {
        throw new Error("Home response status", response.status);
      }

      const url = getHomeRedirectURL(window.location);
      window.location.href = url;
    })
    .catch(error => {
      console.error(error);
    });
};
